//NOT WORKING
import { MEDIA_TYPE_APPLICATION_JSON } from '../constants';
import networkConfig from './config';
import URI from 'urijs';
// eslint-disable-next-line unused-imports/no-unused-vars
// eslint-disable-next-line @typescript-eslint/no-var-requires
const URITemplate = require('urijs/src/URITemplate');
import App from '../App';
import axios from 'axios';
import { store } from '../redux/Store';
import { setApiError } from '../redux/Actions/ErrorAction';
import { HEADER_REQUEST_ID, HEADER_SESSION_ID } from '../constants';
import AuthManager from '../auth/AuthManager';
import { trackPromise } from 'react-promise-tracker';
import Akamai from './interceptors/Akamai';
axios.interceptors.request.use(Akamai.instance.onFulfilled, Akamai.instance.onRejected);
export const getInvokeOptionsForHTTPMethod = (postData, options, invokeOption, urlEncodedData) => {
    if (postData) {
        switch (options.httpMethod) {
            case 'POST':
                invokeOption = urlEncodedData
                    ? { ...invokeOption, data: urlEncodedData }
                    : {
                        ...invokeOption,
                        data: JSON.stringify(postData),
                    };
                break;
            case 'PUT':
            case 'DELETE':
                invokeOption = { ...invokeOption, data: JSON.stringify(postData) };
                break;
            default:
        }
    }
    return invokeOption;
};
// Success callback
export const onSuccessCallback = async (response) => {
    if (response?.response?.error) {
        return Promise.reject(response);
    }
    return response;
};
export const onErrorCallback = async (error) => {
    return { status: error?.status, response: null };
};
const isValidJSON = (item) => {
    let itemToValidate = typeof item !== 'string' ? JSON.stringify(item) : item;
    try {
        itemToValidate = JSON.parse(itemToValidate);
    }
    catch (e) {
        return false;
    }
    return typeof itemToValidate === 'object' && itemToValidate !== null;
};
export const handleError = async (error) => {
    if (error.response) {
        const response = error.response;
        if (isValidJSON(response?.data)) {
            return onSuccessCallback({
                status: response?.status,
                response: response?.data,
            });
        }
        error.status = response?.status;
    }
    else if (error.request) {
        error.status = error.request?._timeout ? 524 : 404;
    }
    return onErrorCallback(error);
};
export const createErrorResponseObj = (url, options, error) => {
    const errorCode = error?.response?.status ?? (error?.request?._timeout ? 524 : 404);
    const message = error?.response?.request?._response ?? error?.request?._response ?? error?.message;
    return {
        method: options?.method,
        url,
        correlationRequestId: options?.headers?.[HEADER_REQUEST_ID],
        correlationSessionId: options?.headers?.[HEADER_SESSION_ID],
        errorCode: JSON.stringify(errorCode),
        message: typeof message !== 'string' ? JSON.stringify(message) : message,
        response: isValidJSON(error?.response?.data) ? JSON.stringify(error?.response?.data) : error?.response?.data,
        stack: JSON.stringify(error?.stack),
    };
};
const invokeApi = async (options, data = null, header = null, postData = null, urlEncodedData = null, request = null) => {
    let invokeOption = {};
    let url = '';
    try {
        let reqHeader = {
            Accept: MEDIA_TYPE_APPLICATION_JSON,
            'Content-Type': MEDIA_TYPE_APPLICATION_JSON,
            // "x-is-registered-user": true, // TODO: should replace both keys and make it dynamic after login integration
            // "x-user-id": '4e327d57-6eca-4a0f-bd15-ddd2cc905467', // For DEV Envcca3f8a3-d0d2-4ced-ba42-3b18414ee429 // For QA Env4e327d57-6eca-4a0f-bd15-ddd2cc905467
            //'x-tenant-id': '15895bb59f7b4bb588ee933f8cd5344a', // hardcoding as of now.
        };
        if (header) {
            reqHeader = { ...reqHeader, ...header };
        }
        invokeOption = {
            ...(!data?.disableHeaders && { headers: reqHeader }),
            method: options.httpMethod,
        };
        invokeOption = await getModifiedHeader(options, invokeOption, request);
        invokeOption = getInvokeOptionsForHTTPMethod(postData, options, invokeOption, urlEncodedData);
        url = networkConfig.getBaseUrl(options.name) + options.url;
        if (options?.hasQueryProps && options?.hasNamedProps) {
            url += URI.buildQuery(data.queryProps);
        }
        else if (options?.hasQueryProps && !options?.hasNamedProps) {
            const uriObj = URI.expand(url, data.queryProps);
            const protocol = uriObj.protocol();
            const hostName = uriObj.hostname();
            const path = uriObj.path();
            const port = uriObj.port();
            url = port ? `${protocol}://${hostName}:${port}${path}` : `${protocol}://${hostName}${path}`;
        }
        const apiPromise = axios({ url, timeout: App.envVars?.requestTimeoutSecs, ...invokeOption }).then((response) => {
            return onSuccessCallback({
                status: response.status,
                response: response.data,
                headers: response.headers,
            });
        });
        if ((options.httpMethod === 'POST' || options.httpMethod === 'PUT') && (options.showLoader ?? true)) {
            // eslint-disable-next-line no-console
            console.log(`tracking API resource: ${options.httpMethod} ${options.url}`);
            return await trackPromise(apiPromise);
        }
        else {
            return await apiPromise;
        }
    }
    catch (error) {
        const errMsg = createErrorResponseObj(url, invokeOption, error);
        store.dispatch(setApiError(errMsg));
        return handleError(error);
    }
};
export default invokeApi;
async function getModifiedHeader(options, invokeOption, request) {
    const { tenantReducer } = store?.getState();
    if (options?.isAuthenticated) {
        const authToken = await AuthManager.getInstance().checkAndGetAuthToken();
        invokeOption = {
            ...invokeOption,
            headers: {
                ...invokeOption.headers,
                Authorization: 'Bearer ' + authToken,
            },
        };
    }
    if (options?.isXCorelationEnabled) {
        invokeOption = {
            ...invokeOption,
            headers: {
                ...invokeOption.headers,
                ...networkConfig.getXCorelationHeader(),
            },
        };
    }
    if (App.envVars?.language && !options?.skipLanguage && tenantReducer?.allowXLanguage) {
        invokeOption = {
            ...invokeOption,
            headers: {
                ...invokeOption.headers,
                'x-language': App.envVars?.language,
            },
        };
    }
    if (options?.allowSiteOrigin && request?.payload?.siteOrigin) {
        invokeOption = {
            ...invokeOption,
            headers: {
                ...invokeOption.headers,
                'x-site-origin': request?.payload?.siteOrigin,
            },
        };
    }
    if (options?.overrideRequestHeader) {
        let overrideHeader = {};
        if (options?.authToken)
            overrideHeader = { ...overrideHeader, Authorization: 'Bearer ' + options?.authToken };
        if (options?.appchannel)
            overrideHeader = { ...overrideHeader, 'app-source': options?.appchannel };
        if (options?.xCorrelationSessionId)
            overrideHeader = { ...overrideHeader, 'app-source': options?.xCorrelationSessionId };
        invokeOption = {
            ...invokeOption,
            headers: {
                ...invokeOption.headers,
                ...overrideHeader,
            },
        };
    }
    return invokeOption;
}
export const appendLocaleInCMSRequest = (params) => {
    if (App.envVars?.language) {
        return {
            ...params,
            locale: App.envVars?.language,
        };
    }
    return { ...params };
};
